import axios from 'axios';

export interface ZkiliRedirectConfig {
    redirect: string;
    name: string;
    corporation: string;
    ship: string;
    shipId: number;
    aggressorName: string;
    aggressorCorporation: string;
    aggressorShip: string;
    system: string;
    region: string;
    value: number;
}

export interface ZkiliRedirectConfigGetResponse {
    id: number;
    createdAt: number;
    updatedAt: number;
    config: ZkiliRedirectConfig;
    linkId: number;
}

const ZkiliRedirectsApi = {
    get: (id): Promise<ZkiliRedirectConfigGetResponse> => {
        return axios
            .get(`${process.env.REACT_APP_API_BASE}/api/zkili-redirects/${id}`, { withCredentials: true })
            .then(response => response.data);
    },
    list: (): Promise<ZkiliRedirectConfigGetResponse[]> => {
        return axios
            .get(`${process.env.REACT_APP_API_BASE}/api/zkili-redirects`, { withCredentials: true })
            .then(response => response.data);
    },
    update: async (id, config: ZkiliRedirectConfig) => {
        return axios
            .put(`${process.env.REACT_APP_API_BASE}/api/zkili-redirects/${id}`, { config }, { withCredentials: true })
            .then(response => response.data);
    },
    create: async (config: ZkiliRedirectConfig) => {
        return axios
            .post(`${process.env.REACT_APP_API_BASE}/api/zkili-redirects`, { config }, { withCredentials: true })
            .then(response => response.data);
    },
    deleteLink: async id => {
        return axios
            .delete(`${process.env.REACT_APP_API_BASE}/api/zkili-redirects/${id}`, { withCredentials: true })
            .then(response => response.data);
    }
};

export default ZkiliRedirectsApi;
